import "../../../assets/RideModal.css";
import { RideButton as w } from "../button/RideButton.js";
import c from "clsx";
import l, { useRef as $, useState as A, useEffect as L } from "react";
import { ModalOverlay as p, Modal as D, Dialog as G } from "react-aria-components";
import { useSlots as I } from "../../../hooks/useSlots.js";
import { RideGlError as m } from "../graphic/glyph/components/RideGlError.js";
import { RideIconButton as j } from "../icon-button/RideIconButton.js";
const q = "_modal_66e86_79", F = "_header_66e86_85", H = "_dialog_66e86_97", J = "_old_66e86_109", K = "_container_66e86_145", P = "_rotate_66e86_1", Q = "_loading_66e86_1", e = {
  "ride-modal": "_ride-modal_66e86_54",
  "fade-in": "_fade-in_66e86_1",
  "fade-out": "_fade-out_66e86_1",
  "overlay-color-default": "_overlay-color-default_66e86_70",
  "overlay-color-subtle": "_overlay-color-subtle_66e86_73",
  "overlay-blur-subtle": "_overlay-blur-subtle_66e86_76",
  modal: q,
  header: F,
  dialog: H,
  "close-button-text": "_close-button-text_66e86_102",
  "close-icon-button": "_close-icon-button_66e86_106",
  old: J,
  "size-small": "_size-small_66e86_112",
  "size-medium": "_size-medium_66e86_115",
  new: "_new_66e86_123",
  "full-screen": "_full-screen_66e86_138",
  container: K,
  rotate: P,
  loading: Q,
  "slide-in-up": "_slide-in-up_66e86_1",
  "slide-in-down": "_slide-in-down_66e86_1",
  "fill-center-out": "_fill-center-out_66e86_1"
};
function h({
  "aria-label": n,
  children: u,
  className: f,
  isDismissable: b = !0,
  "data-testid": y,
  onCloseButtonClick: o,
  onOpenChange: t,
  isOpen: a = !1,
  overlayBlur: E,
  overlayColor: v = "default",
  size: R = "small",
  variant: r = "old",
  fullScreen: s
}) {
  const g = $(null), { RideModalContent: d, RideModalActions: _ } = I(u), [x, z] = A(!1);
  L(() => {
    a && (t == null || t(!0));
  }, [a]);
  const M = () => c(
    e["ride-modal"],
    e[`overlay-color-${v}`],
    e[`overlay-blur-${E}`],
    f
  ), i = (N) => {
    t == null || t(!1), o == null || o(N);
  };
  return /* @__PURE__ */ l.createElement(
    p,
    {
      className: M(),
      isOpen: a,
      isDismissable: b,
      onOpenChange: t,
      "data-testid": y
    },
    /* @__PURE__ */ l.createElement(
      D,
      {
        className: c(
          e.modal,
          e[`size-${R}`],
          e[r],
          {
            [e["full-screen"]]: s
          }
        )
      },
      /* @__PURE__ */ l.createElement(G, { className: e.dialog, "aria-label": n }, /* @__PURE__ */ l.createElement("div", { className: e.header }, /* @__PURE__ */ l.createElement(
        w,
        {
          text: "Cerrar",
          variant: "text-secondary",
          glyph: /* @__PURE__ */ l.createElement(m, null),
          className: e["close-button-text"],
          onClick: i,
          size: "large"
        }
      ), /* @__PURE__ */ l.createElement(
        j,
        {
          className: e["close-icon-button"],
          size: "large",
          variant: "unfill",
          glyph: /* @__PURE__ */ l.createElement(m, null),
          onClick: i,
          ref: g
        }
      )), d && l.cloneElement(d, {
        variant: r,
        fullScreen: s,
        hasActions: !!_,
        onLargeContentChange: z
      }), _ && l.cloneElement(_, {
        variant: r,
        fullScreen: s,
        largeContent: x
      }))
    )
  );
}
export {
  h as RideModal
};
